export default __webpack_public_path__ + "static/media/sumup-icon.db42889a.png";